module.exports = __webpack_public_path__ + "fonts/ropa-sans-v9-latin-ext_latin-regular.woff2?5345bae84a6c96382860066dce0db4f1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ropa-sans-v9-latin-ext_latin-regular.woff2
// module id = 316
// module chunks = 0